/**
 * Labstep
 *
 * @module components/ProtocolDevice/ListItem
 * @desc Protocol Device item
 */

import { DevicePreview } from 'labstep-web/components/Device/Preview';
import { ProtocolDeviceActionMenu } from 'labstep-web/components/ProtocolDevice/Action/Menu';
import { ICONS } from 'labstep-web/constants/icons';
import { ElementCard } from 'labstep-web/core/Card/Element';
import type React from 'react';
import type { IProtocolDeviceListItemProps } from './types';

export const ProtocolDeviceListItem: React.FC<
  IProtocolDeviceListItemProps
> = ({ protocolDevice }) =>
  protocolDevice.device ? (
    <DevicePreview
      device={protocolDevice.device}
      modalProps={{
        viewComponent: ({ toggleModal }) => (
          <ElementCard
            dataCy="components/ProtocolDevice/ListItem"
            icon={ICONS.device.primary}
            name={protocolDevice.name}
            onClick={toggleModal}
            actions={
              <ProtocolDeviceActionMenu
                protocolDevice={protocolDevice}
                actions={['delete']}
              />
            }
          />
        ),
      }}
    />
  ) : null;
